<template>
  <div class="flex justify-between items-center px-3 pb-1">
    <NText variant="h3" tag="h3" weight="bold">
      {{ instrumentName }}
    </NText>

    <div class="flex items-center py-1 px-2 rounded-3xl bg-critical-secondary">
      <NText variant="overline" weight="medium" class="text-critical-secondary">
        {{ t('option.expired') }}
      </NText>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

type TExpiredPositionCardProps = {
  instrumentName: string;
};

defineProps<TExpiredPositionCardProps>();

const { t } = useI18n();
</script>
